/* eslint-disable react/no-direct-mutation-state */
// 设置展开栏群成员

import React, { ReactNode, useCallback, useEffect, useMemo, useState, useRef } from "react";
import "./index.less";
import { Input, Checkbox, Modal, Button, message as toast } from "antd";
import {
  ChatMessage,
  ChatMessageType,
  Employee,
  MessageEmitCategory,
  MessageStatus,
  Session
} from "@/types/chat/";
import ChatState from "@/types/chat/State";
import { connect } from "dva";
import Context from "@/components/chat/context";
import bus from "@/utils/bus";
import { getMessageDateFormat, isSameDay } from "@/utils/date";
import { MessageDateFormType } from "@/types/chat/enum";
import TimeLine from "@/components/chat/message/Time/Line";
import SimpleTime from "@/components/chat/message/Time/Simple";
import ImService from "@/server/ImService";
import ChattingRecordsContainer from "./ChattingRecordsContainer";
import { getLatestMessages, messageCompare } from "@/utils/chat/message";

interface IProps {
  selectedSession: Session;
}

function ChattingRecordsModal(props: IProps) {
  const { selectedSession } = props;

  const [visible, setVisible] = useState(false);
  const [selectedRecords, setSelectedRecords] = useState<ChatMessage[]>([]);
  const [selectedRecordIds, setSelectedRecordIds] = useState<string[]>([]);
  const [chattingRecords, setChattingRecords] = useState<ChatMessage[]>([]);
  const [modalMessages, setModalMessages] = useState<ChatMessage[]>([]);
  const [checkedVisible, setCheckedVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [zIndex, setZIndex] = useState(1001);
  const [isEnd, setIsEnd] = useState(true);
  const loadingRef = useRef(false);
  const [fetched, setFetched] = useState(false);
  const recordsListRef = useRef<HTMLDivElement | null>(null);
  const preStartMidRef = useRef<number>(0);
  const nodeRef = useRef(null);

  const loadHistory = useCallback(
    (startMid, options = {}) => {
      const imService = ImService.getInstance();
      return imService.loadHistory(selectedSession.sessionId, startMid, false, options);
    },
    [selectedSession]
  );

  const searchMessages = useCallback(
    (startMid?: number, records?: ChatMessage[]) => {
      if (loadingRef.current) return;
      loadingRef.current = true;
      loadHistory(startMid ? (startMid === -1 ? startMid : startMid - 1) : -1, {
        queryType: 2,
        count: 200
      })
        .then(({ messages, end }: any) => {
          const _messages = getLatestMessages([...messages]).sort(messageCompare);
          setIsEnd(end === 1);
          // const list: ChatMessage[] = messages.sort(
          //   (a: any, b: any) => a.timestamp - b.timestamp
          // ) as ChatMessage[];
          if (startMid && startMid !== -1 && records) {
            preStartMidRef.current = startMid;
            setChattingRecords([...(_messages as ChatMessage[]), ...records]);
          } else {
            setChattingRecords(_messages as ChatMessage[]);
          }
          loadingRef.current = false;
        })
        .catch((e) => {
          loadingRef.current = false;
          setIsEnd(true);
        });
    },
    [loadHistory]
  );

  useEffect(() => {
    if (checkedVisible && visible) {
      searchMessages(-1);
    }
  }, [searchMessages, checkedVisible, visible, selectedSession]);

  const handleModalShow = useCallback(
    (data) => {
      const { records = [], modalData, canChecked } = data;
      setSelectedRecords([...records]);
      setSelectedRecordIds(records.map((m: any) => m.id));
      console.log("modalData=>", modalData);
      if (modalData?.length) {
        setChattingRecords(modalData);
        setModalMessages(modalData);
      }
      if (canChecked) {
        setZIndex(1001);
      } else {
        setZIndex(99);
      }
      setCheckedVisible(canChecked);
      setVisible(true);
      setModalTitle(selectedSession?.info?.name);
      setTimeout(() => {
        const curr = recordsListRef.current;
        curr?.scrollTo(0, curr.scrollHeight);
        setFetched(true);
      }, 600);
    },
    [selectedSession]
  );

  useEffect(() => {
    bus.on("chatting-records-modal-show", handleModalShow);
    return () => {
      bus.off("chatting-records-modal-show", handleModalShow);
    };
  }, [handleModalShow]);

  const clearSelectedData = () => {
    setSelectedRecordIds([]);
    setSelectedRecords([]);
  };
  const onCancel = () => {
    clearSelectedData();
    setChattingRecords([]);
    setIsEnd(true);
    setCheckedVisible(false);
    setFetched(false);
    setVisible(false);
    setModalTitle("");
  };
  const onOk = () => {
    if (!checkedVisible) {
      setVisible(false);
      return;
    }
    bus.emit("selectChattingRecordsConfirm", selectedRecords);
    setChattingRecords([]);
    setIsEnd(true);
    setCheckedVisible(false);
    setFetched(false);
    setVisible(false);
  };

  const getSimpleTimeNode = (messages: ChatMessage[], prevMessages: ChatMessage[]): ReactNode => {
    const timestamp = messages[0].timestamp;
    let prev_timestamp = Date.now();
    if (prevMessages?.length) {
      prev_timestamp = prevMessages[prevMessages.length - 1].timestamp;
    }
    if (!isSameDay(timestamp, prev_timestamp)) {
      return (
        <div>
          <TimeLine timeStamp={timestamp} />
          <SimpleTime timeStamp={timestamp} />
        </div>
      );
    } else {
      if (timestamp - prev_timestamp > 60 * 1000) {
        return <SimpleTime timeStamp={timestamp} />;
      } else {
        return <div />;
      }
    }
  };

  const handleSelectChatRecord = useCallback(
    (message: ChatMessage) => {
      if (
        checkedVisible &&
        !message.plusList &&
        message.type !== ChatMessageType.SOLITAIRE &&
        message.type !== ChatMessageType.GROUPNOTICE &&
        message.category === MessageEmitCategory.CHAT_MESSAGE &&
        message.revoke !== 1 &&
        message.statusType !== MessageStatus.EXPIRED
      ) {
        if (selectedRecordIds.includes(message.id)) {
          const index = selectedRecordIds.findIndex((id) => id === message.id);
          selectedRecordIds.splice(index, 1);
          selectedRecords.splice(index, 1);
        } else {
          if (selectedRecordIds.length === 100) {
            return toast.info("最多支持选择100条沟通记录");
          }
          selectedRecordIds.push(message.id);
          selectedRecords.push(message);
        }
        setSelectedRecordIds([...selectedRecordIds]);
        setSelectedRecords([...selectedRecords]);
      }
    },
    [selectedRecordIds, selectedRecords, checkedVisible]
  );

  const messageGroups = useMemo(() => {
    if (!chattingRecords.length) {
      return [];
    }
    const groups: Array<ChatMessage[]> = [];
    let temp: ChatMessage[] = [];
    chattingRecords.forEach((m: ChatMessage) => {
      if (!temp.length) {
        temp.push(m);
        return;
      }

      if (m.id !== temp[temp.length - 1].id) {
        groups.push([...temp]);
        temp = [m];
        return;
      }
      temp.push(m);
    });
    if (temp.length) {
      groups.push([...temp]);
    }
    return groups;
  }, [chattingRecords]);

  const handleUnselect = () => {
    setSelectedRecordIds([]);
    setSelectedRecords([]);
  };

  const loadMoreData = useCallback(() => {
    if (!visible || !checkedVisible) return;
    if (isEnd || loadingRef.current || !fetched) return;
    console.log("loadMoreData");
    const startMid = chattingRecords[0].mid;
    searchMessages(startMid, chattingRecords);
  }, [searchMessages, chattingRecords, visible, isEnd, checkedVisible, fetched]);

  const content = useMemo(() => {
    return messageGroups.map((messages, index) => {
      if (!messages[0].id) {
        return <div key={index} />;
      }
      return (
        <div key={`key-${messages[0].id}-${index}`}>
          {index > 0 ? (
            getSimpleTimeNode(messages, messageGroups[index - 1])
          ) : (
            <SimpleTime timeStamp={messages[0].timestamp} />
          )}
          <ChattingRecordsContainer
            key={`k-${messages[0].id}`}
            messages={messages}
            handleSelectChatRecord={handleSelectChatRecord}
            checkedVisible={checkedVisible}
            selectedRecordIds={selectedRecordIds}
            isInviteForward={modalMessages.length > 0}
            modalMessages={modalMessages}
          />
          {/* {messages.map((message) => (
            <div className="chat-records-item" key={`c-${message.id}-${message.timestamp}`}>
              <div
                className={`message-node ${checkedVisible ? "readOnly" : ""}`}
                onClick={() => handleSelectChatRecord(message)}
              >
                {getContent(message, messages)}
              </div>
            </div>
          ))} */}
        </div>
      );
    });
  }, [checkedVisible, handleSelectChatRecord, messageGroups, modalMessages, selectedRecordIds]);

  const observerRef = useRef<IntersectionObserver | null>();
  const observerOptionsRef = useRef({ threshold: 1 });

  const observeCallback = useCallback(
    (entries) => {
      const first = entries[0];
      const ifItemInView =
        first.isIntersecting && first.intersectionRatio >= observerOptionsRef.current.threshold;
      if (ifItemInView) {
        loadMoreData();
      }
    },
    [loadMoreData]
  );

  useEffect(() => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    observerRef.current = new IntersectionObserver(observeCallback, observerOptionsRef.current);
    const elementNode = nodeRef.current;
    if (!isEnd) {
      if (elementNode) {
        observerRef.current.observe(elementNode);
      }
    } else {
      if (elementNode) {
        observerRef.current.unobserve(elementNode);
      }
    }
    return () => {
      observerRef.current?.disconnect();
    };
  }, [observeCallback, isEnd]);

  return (
    visible && (
      <Modal
        zIndex={zIndex}
        visible={visible}
        title={modalTitle}
        okText="确定"
        cancelText="取消"
        onCancel={onCancel}
        className="chat-records-modal"
        width={600}
        centered
        footer={
          <div className="chat-records-modal-footer">
            {checkedVisible ? (
              <div>
                <span className="text">已选择：{selectedRecords.length}条消息</span>
                <span className="unselect-btn" onClick={handleUnselect}>
                  取消选择
                </span>
              </div>
            ) : (
              <div />
            )}

            <div className="btn-group">
              <Button onClick={onCancel}>取消</Button>
              <Button onClick={onOk} type="primary">
                确定
              </Button>
            </div>
          </div>
        }
      >
        <div className="chat-records-modal-content">
          <div className="chat-records-list" ref={recordsListRef}>
            <div className="infiniteScroll">
              <div className="container">
                {!isEnd && fetched && <div className="observer-element" ref={nodeRef} />}
                {content}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession } = chat as ChatState;
  return { selectedSession };
}
function mapDispatchToProps(dispatch: any) {
  return {
    async updateGroupMembers(data: { groupRosters: any }) {
      await dispatch({ type: "chat/updateGroupMembers", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChattingRecordsModal);
